import { Helmet } from "react-helmet";
import BreadCrumb from "../../component/BreadCrumb";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AxiosClient from "../../client/AxiosClient";
import { API_GET_CATEGORY, API_GET_CATEGORY_COURSES } from "../../ApiEndPoints";
import { useParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import AllCourses from "../../sections/AllCourses";
import Loader from "../../component/Loader";
import ErrorBoundaryWrap from "../../error-boundries/ErrorBoundaryWrap";
import ErrorBoundryWrapParent from "../../error-boundries/ErrorBoundryWrapParent";

export default function CategoryCoursesPage() {
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [category, setCategory] = useState(null);

  const params = useParams();

  // fetch category
  useEffect(() => {
    setCategoryLoading(true);
    AxiosClient.get(`${API_GET_CATEGORY}${params.slug}`)
      .then((response) => setCategory(response.data.data))
      .catch(console.error)
      .finally(() => setCategoryLoading(false));
  }, [params.slug]);

  // courses
  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [courseLoading, setCourseLoading] = useState(true);

  const limit = process.env.REACT_APP_PAGINATION_LIMIT || 12;
  const hasFetchedRef = useRef(false);

  const fetchData = async (pageToFetch, replace = false) => {
    try {
      const response = await AxiosClient.get(
        API_GET_CATEGORY_COURSES + params.slug,
        { params: { page: pageToFetch, limit } }
      );

      const newItems = response.data.data.items;
      const total = response.data.data.total;

      setCourses((prev) => {
        const updated = replace ? newItems : [...prev, ...newItems];
        if (updated.length >= total) setHasMore(false);
        return updated;
      });

      if (newItems.length > 0) {
        setPage(pageToFetch + 1); // increment correctly
      }

      setCourseLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // reset on slug change
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setCourseLoading(true);
    hasFetchedRef.current = false;

    // fetch the first page explicitly
    fetchData(1, true);
  }, [params.slug]);

  return (
    <main>
      <Helmet>
        <title>
          {category == null ? "Category" : category.name} |{" "}
          {process.env.REACT_APP_NAME}
        </title>
      </Helmet>

      <ErrorBoundryWrapParent>
        <BreadCrumb
          title={category == null ? "Loading ..." : category.name}
          desc={`Browse our extensive range of ${
            category == null ? "law courses" : category.name
          }, carefully designed to enhance your legal knowledge and skills.`}
        />
      </ErrorBoundryWrapParent>

      <section>
        <div className="container">
          {!courseLoading && (
            <InfiniteScroll
              className="inifit-scroll__wrap"
              dataLength={courses.length}
              next={() => fetchData(page)} // ✅ pass current page explicitly
              hasMore={hasMore}
              loader={
                <div className="text-center">
                  <Loader />
                </div>
              }
              endMessage={
                <p className="text-center mt-3">
                  <b className="fw-500 bg-light p-2  border border-primary rounded-2">
                    No more courses found! Check back later.
                  </b>
                </p>
              }
            >
              <AllCourses courses={courses} />
            </InfiniteScroll>
          )}

          {courseLoading && (
            <div className="text-center">
              <Loader />
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
